import { Client } from 'src/api/Client';
import { UserMemoryResponse, UpdateUserMemoryRequest } from './UserMemoryClient.types';

class UserMemoryClient extends Client {
  private readonly Route = {
    USER_MEMORY: `${this.http.baseUrl}/ai-agent/user-memory/{brandId}`,
    UPDATE_USER_MEMORY: `${this.http.baseUrl}/ai-agent/user-memory/{brandId}`,
  };

  /**
   * Get user memory data for a specific brand
   * @param brandId - The brand ID to fetch memory for
   * @returns Promise<UserMemoryResponse>
   */
  getUserMemory(brandId: string): Promise<UserMemoryResponse> {
    const url = this.Route.USER_MEMORY.replace('{brandId}', brandId);
    return this.http.get<UserMemoryResponse>(url) as unknown as Promise<UserMemoryResponse>;
  }

  /**
   * Update user memory data for a specific brand
   * @param brandId - The brand ID to update memory for
   * @param data - The update request data
   * @returns Promise<UserMemoryResponse>
   */
  updateUserMemory(brandId: string, data: UpdateUserMemoryRequest): Promise<UserMemoryResponse> {
    const url = this.Route.UPDATE_USER_MEMORY.replace('{brandId}', brandId);
    return this.http.put<UserMemoryResponse>(url, data) as unknown as Promise<UserMemoryResponse>;
  }
}

export { UserMemoryClient };
